<template>
  <div class="searchComponent">
    <section class="formPage uk-text-nowrap">
      <el-form v-bind="$attrs" ref="formSearch" :model="SearchForm">
        <el-form-item>
          <el-select
            v-model="valueParam"
            class="select"
            value-key="id"
            :placeholder="$t('public.please')"
            @change="changeFn"
          >
            <el-option
              v-for="item in formContent"
              :key="item.id"
              :label="$t(item.text)"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 这里说明一下  因为用指令 的方式的话 会导致有一些位置的错乱 -->
        <el-popover
          ref="popover"
          placement="bottom-start"
          width="820"
          trigger="click"
        >
          <el-form
            ref="SearchForm"
            :inline="true"
            label-width="150px"
            :model="SearchForm"
          >
            <div v-for="item in formContent" :key="item.id" class="popoverForm">
              <el-form-item>
                <table>
                  <tr>
                    <td>
                      <label slot="label">
                        <div class="popoverContent">
                          <el-checkbox
                            class="checkbox"
                            v-model="item.isChooze"
                            :disabled="item.disabled"
                          ></el-checkbox>
                          <div class="text" :title="$t(item.text)">
                            {{ $t(item.text) }}
                          </div>
                        </div>
                      </label>
                    </td>
                    <td>
                      <template v-if="item.type === 'input'">
                        <el-input
                          style="width:250px"
                          v-model="SearchForm[item.paramsName]"
                          :disabled="item.disabled"
                        ></el-input>
                      </template>

                      <template v-else-if="item.type === 'select'">
                        <el-select
                          style="width:250px"
                          v-model="SearchForm[item.paramsName]"
                          :placeholder="$t('placeholderText.Choose')"
                        >
                          <el-option
                            v-for="option in item.selectParam"
                            :key="option.value"
                            :label="$t(`${option.label}`)"
                            :value="option.value"
                          >
                            <span style="margin-right: 10px;">
                              <i :class="option.icon"></i>
                            </span>
                            <span>{{ $t(`${option.label}`) }}</span>
                          </el-option>
                        </el-select>
                      </template>
                      <template v-else-if="item.type === 'date'">
                        <el-date-picker
                          style="width:320px"
                          v-model="SearchForm[item.paramsName]"
                          type="daterange"
                          :range-separator="$t('public.to')"
                          :start-placeholder="$t('public.start_date')"
                          :end-placeholder="$t('public.end_date')"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </template>
                      <template v-else-if="item.type === 'time'">
                        <el-time-picker
                          v-model="SearchForm[item.paramsName]"
                          :placeholder="$t('integration.any_point_in_time')"
                          value-format="HH:mm"
                        ></el-time-picker>
                      </template>
                      <template v-else-if="item.type === 'times'">
                        <div class="to-parent-class">
                          <el-time-picker
                            v-model="SearchForm[item.paramsName]"
                            :placeholder="$t('integration.any_point_in_time')"
                            value-format="HH:mm"
                          ></el-time-picker>
                          <div class="to-class">To</div>
                          <el-time-picker
                            v-model="SearchForm[item.paramsName2]"
                            :placeholder="$t('integration.any_point_in_time')"
                            value-format="HH:mm"
                          ></el-time-picker>
                        </div>
                      </template>
                      <template v-else-if="item.type === 'datetime'">
                        <el-date-picker
                          style="width:250px"
                          v-model="SearchForm[item.paramsName]"
                          type="datetime"
                          :placeholder="$t('placeholderText.ChooseStartTime')"
                        >
                        </el-date-picker>
                      </template>

                      <template v-else-if="item.type === 'datetimerange'">
                        <el-date-picker
                          style="width:320px"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="SearchForm[item.paramsName]"
                          type="datetimerange"
                          :picker-options="pickerOptions"
                          :range-separator="$t('public.to')"
                          :start-placeholder="$t('public.start_date')"
                          :end-placeholder="$t('public.end_date')"
                        >
                        </el-date-picker>
                      </template>

                      <template v-else-if="item.type === 'selecttree'">
                        <el-select
                          style="width:250px"
                          v-model="item.label"
                          :placeholder="$t('messageTitle.PleaseSelectArchit')"
                          popper-class="Architecture"
                        >
                          <el-option :value="item.label">
                            <section class="treeClass">
                              <trees
                                @changeNode="
                                  nodeClick(
                                    $event,
                                    item,
                                    item.paramsName,
                                    choozeArray[0].nodeId
                                  )
                                "
                                :treedata="dataTree"
                                ref="tree"
                              />
                            </section>
                          </el-option>
                        </el-select>
                      </template>
                    </td>
                  </tr>
                </table>

                <slot name="popoverContent"></slot>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button type="primary" @click="confirmFn"
                >{{ $t('public.btn_confirm') }}
              </el-button>
            </el-form-item>
          </el-form>
          <!-- <span class="icon" slot="reference">
              <i class="el-icon-plus"></i>
          </span> -->
          <div class="icon" slot="reference">
            <i class="el-icon-plus"></i>
          </div>
        </el-popover>
        <!-- input -->
        <template
          v-if="choozeArray.length > 0 && choozeArray[0].type === 'input'"
        >
          <el-form-item>
            <el-input
              class="param"
              @input="inputFn"
              :disabled="choozeArray[0].disabled"
              v-model="SearchForm[choozeArray[0].paramsName]"
            ></el-input>
          </el-form-item>
        </template>
        <!-- select -->
        <template
          v-else-if="choozeArray.length > 0 && choozeArray[0].type === 'select'"
        >
          <el-form-item>
            <el-select
              class="param"
              v-model="SearchForm[choozeArray[0].paramsName]"
              :placeholder="$t('placeholderText.Choose')"
              @change="handleChange($event, choozeArray[0].selectParam)"
            >
              <el-option
                v-for="option in choozeArray[0].selectParam"
                :key="option.value"
                :label="$t(option.label)"
                :value="option.value"
              >
                <span style="margin-right: 10px;">
                  <i :class="option.icon"></i>
                </span>
                <span>{{ $t(`${option.label}`) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <!-- 单个时间 -->
        <template
          v-else-if="choozeArray.length > 0 && choozeArray[0].type === 'time'"
        >
          <el-form-item>
            <el-time-picker
              v-model="SearchForm[choozeArray[0].paramsName]"
              :placeholder="$t('integration.any_point_in_time')"
              value-format="HH:mm"
            ></el-time-picker>
          </el-form-item>
        </template>
        <!-- 单个时间 -->
        <template
          v-else-if="choozeArray.length > 0 && choozeArray[0].type === 'times'"
        >
          <el-form-item>
            <div class="to-parent-class">
              <el-time-picker
                v-model="SearchForm[choozeArray[0].paramsName]"
                :placeholder="$t('integration.any_point_in_time')"
                value-format="HH:mm"
              >
              </el-time-picker>
              <div class="to-class">To</div>
              <el-time-picker
                v-model="SearchForm[choozeArray[0].paramsName2]"
                :placeholder="$t('integration.any_point_in_time')"
                value-format="HH:mm"
              >
              </el-time-picker>
            </div>
          </el-form-item>
        </template>
        <!-- 单个时间 -->
        <template
          v-else-if="
            choozeArray.length > 0 && choozeArray[0].type === 'datetime'
          "
        >
          <el-form-item>
            <el-date-picker
              class="param-date-picker"
              @change="changeTimeFn"
              v-model="SearchForm[choozeArray[0].paramsName]"
              type="datetime"
              :placeholder="$t('placeholderText.ChooseStartTime')"
            ></el-date-picker>
          </el-form-item>
        </template>
        <!-- 日期选择器 -->
        <template
          v-else-if="choozeArray.length > 0 && choozeArray[0].type === 'date'"
        >
          <el-form-item>
            <el-date-picker
              class="param-date-picker"
              v-model="SearchForm[choozeArray[0].paramsName]"
              type="daterange"
              :range-separator="$t('public.to')"
              :start-placeholder="$t('public.start_date')"
              :end-placeholder="$t('public.end_date')"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </template>
        <!-- 日期时间段 -->
        <template
          v-else-if="
            choozeArray.length > 0 && choozeArray[0].type === 'datetimerange'
          "
        >
          <el-form-item>
            <el-date-picker
              class="param-date-picker"
              @change="changeTimeFn"
              v-model="SearchForm[choozeArray[0].paramsName]"
              type="datetimerange"
              :picker-options="pickerOptions"
              :range-separator="$t('public.to')"
              :start-placeholder="$t('public.start_date')"
              :end-placeholder="$t('public.end_date')"
            ></el-date-picker>
          </el-form-item>
        </template>

        <!-- selecttree 下拉树-->
        <template
          v-else-if="
            choozeArray.length > 0 && choozeArray[0].type === 'selecttree'
          "
        >
          <el-form-item>
            <el-select
              style="width:250px"
              v-model="choozeArray[0].label"
              :placeholder="$t('messageTitle.PleaseSelectArchit')"
              popper-class="Architecture"
            >
              <el-option :value="choozeArray[0].label">
                <section class="treeClass">
                  <trees
                    @changeNode="
                      nodeClick(
                        $event,
                        choozeArray[0],
                        choozeArray[0].paramsName,
                        choozeArray[0].nodeId
                      )
                    "
                    :treedata="dataTree"
                    ref="tree"
                  />
                </section>
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item>
            <el-input
              style="width:250px"
              v-model="SearchForm[choozeArray[0].paramsName]"
            ></el-input>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button
            type="warning"
            class="formBtn reset"
            icon="el-icon-refresh"
            @click="resetFn"
          ></el-button>
          <el-button
            type="primary"
            class="formBtn search"
            icon="el-icon-search"
            @click="searchFn"
          >
          </el-button>
        </el-form-item>

        <slot></slot>
      </el-form>
    </section>
    <!--  条件排布 -->
    <!-- 有树节点时 只需要一个条件就可以作为展示 -->
    <template v-if="treePathObj && formContentArray.length > 0 && searchTwo">
      <section class="formContent">
        <div
          class="fromContentBox"
          v-for="item in formContentArray"
          :key="item.id"
        >
          <span class="titleText">{{ $t(item.text) }}:</span>
          <span class="paramContent">{{ $t(item.content) || '--' }}</span>
        </div>
        <!-- 特殊要求  -->
        <template v-if="treePathObj">
          <div class="fromContentBox">
            <span class="titleText">{{ $t('public.belong') }}:</span>
            <span class="paramContent">{{ treePathObj || '--' }}</span>
          </div>
        </template>
      </section>
    </template>
    <template v-else>
      <section class="formContent" v-if="isConfirm">
        <div class="fromContentBox" v-for="item in confirmList" :key="item.id">
          <span class="titleText">{{ $t(item.text) }}:</span>
          <span class="paramContent">{{ $t(item.content) || '--' }}</span>
        </div>
      </section>
    </template>
    <!--  -->
    <!-- 按钮操作列 -->
    <!-- <el-checkbox v-model="checked"></el-checkbox> -->
    <slot name="bottom"></slot>
    <v-button v-bind="$attrs" v-on="$listeners"></v-button>
  </div>
</template>

<script>
import pickerOptions from '@/components/search/config/pickerOptions'

export default {
  props: {
    SearchForm: {
      type: Object,
      default: () => {},
      required: true
    },
    formContent: {
      type: Array,
      default: () => []
    },
    treePathObj: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataTree () {
      return this.$store.getters.SchemaTree
    }
  },
  watch: {
    choozeArray: {
      handler (newVal, oldVal) {
        if (
          oldVal.length > 0 &&
          newVal[0].paramsName !== oldVal[0].paramsName
        ) {
          for (const key in this.SearchForm) {
            // 是否存在默认值  且不需要清空默认值
            if (!oldVal[0].default) {
              key === oldVal[0].paramsName ? (this.SearchForm[key] = '') : true
            }
          }
        }
      },
      deep: true
    }
  },
  data () {
    return {
      pickerOptions,
      searchTwo: false,
      checked: false,
      choozeArray: [],
      formContentArray: [],
      formContentChildren: [],
      valueParam: '',
      isConfirm: false,
      confirmList: []
    }
  },
  created () {
    this.valueParam = this.formContent[0]
    this.choozeArray = [this.formContent[0]]
  },
  methods: {
    resetFn () {
      this.isConfirm = false
      this.confirmList = []
      this.formContentArray = []
      this.formContent.map((item, index) => {
        return (item.isChooze = index === 0)
      })
      this.valueParam = this.formContent[0]
      this.choozeArray = [this.formContent[0]]
      /** 将所选择的筛选数据抛出 */
      this.$emit('resetFn', {})
    },
    searchFn () {
      /** 将所选择的筛选数据抛出 */
      // if(this.SearchForm.time.length>0){
      // }
      this.formContentArray = []
      const searchVal = this.choozeArray[0].paramsName
      if (
        this.SearchForm[searchVal] ||
        (this.SearchForm[searchVal] === 0 && this.treePathObj)
      ) {
        this.searchTwo = true
      } else {
        this.searchTwo = false
      }
      let obj = {}
      this.formContent.forEach(opt => {
        if (opt.paramsName === searchVal) {
          let content = null
          if (opt.type === 'select') {
            const item = opt.selectParam.find(
              item => item.value == this.SearchForm[searchVal]
            )
            content = item ? item.label : ''
          } else {
            content = this.SearchForm[searchVal]
          }
          obj = {
            text: opt.text,
            content
          }
        }
      })

      this.formContentArray.push(obj)
      this.$emit('searchFn', this.SearchForm)
    },
    /** 下拉 当下啦时候 需要将数据init */
    changeFn (val) {
      this.choozeArray = [val]
      this.formContent.forEach(opt => {
        opt.isChooze = opt.paramsName === val.paramsName
        // opt.isChooze = this.SearchForm[val.paramsName] ? true : false;
      })

      if (this.formContentArray.length !== 0) {
        this.formContent.forEach(opt => {
          this.formContentArray.forEach(item => {
            if (!opt.isChooze) {
              opt.isChooze = opt.paramsName === item.paramsName
            }
          })
        })
      }
      // 特殊处理
      if (this.SearchForm.nodeId) {
        this.SearchForm.nodeId = 'all'
      }
      if (this.SearchForm.sceneId) {
        this.SearchForm.sceneId = null
      }
      if (this.SearchForm.recordEndTime) {
        this.SearchForm.recordEndTime = null
      }
    },
    timestampToTime (timestamp) {
      var date = new Date(timestamp)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var second = date.getSeconds()
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    confirmFn () {
      this.$refs.popover.showPopper = false
      this.formContentArray = []
      this.formContent.forEach(opt => {
        for (const key in this.SearchForm) {
          if (opt.paramsName === key && opt.isChooze) {
            let content = this.SearchForm[key]
            if (opt.type === 'select') {
              opt.selectParam.forEach(v => {
                if (v.value === this.SearchForm[key]) {
                  content = v.label
                }
              })
            } else if (opt.type === 'datetimerange') {
              if (this.SearchForm[key]) {
                content = `${this.timestampToTime(this.SearchForm[key][0]) ||
                  ' '} -- ${this.timestampToTime(this.SearchForm[key][1]) ||
                  ' '}`
              } else {
                content = null
              }
            } else if (opt.type === 'date') {
              if (this.SearchForm[key]) {
                content = `${this.SearchForm[key][0]} To ${this.SearchForm[key][1]}`
              } else {
                content = null
              }
            }

            ;(opt.content = content), this.formContentArray.push(opt)

            this.choozeArray = [this.formContentArray[0]]
            this.valueParam = this.formContentArray[0]
          }
        }
      })
      this.confirmList = this.formContent.filter(item => item.isChooze)
      this.isConfirm = this.confirmList.length >= 2
      /** 将所选择的筛选数据抛出 */
      const paramsOBJ = this.TODOCompareFn(this.SearchForm, this.formContent)
      this.$emit('confirmFn', paramsOBJ)
    },
    /** 比较 输入了值 但没有勾选的情况 */
    TODOCompareFn (obj = {}, array = []) {
      array.forEach(item => {
        for (const key in obj) {
          if (!item.isChooze && item.paramsName === key) {
            obj[key] = ''
          }
        }
      })
      return obj
    },
    /** input的值发生改变 */
    inputFn (value) {
      this.defineProxyFn({ value })
    },
    /** 下拉值变化的响应 */
    handleChange (num, param) {
      const OBJ = {}
      for (const item of param) {
        item.value === num ? (OBJ.value = item.label) : ''
      }
      this.defineProxyFn(OBJ)
    },
    /** 时间值的改变 */
    changeTimeFn (value) {
      this.defineProxyFn({ value })
    },
    /** 树形的选择 */
    nodeClick (option, item, paramsName) {
      /** 应变各种情况 */
      this.$set(item, 'label', option.label.label)
      this.$set(this.SearchForm, paramsName, option.label.scene_id ? option.label.scene_id : option.label.scope_id)
      /** 抛出一个方法 做特殊处理 */
      this.$emit('nodeClick', option)

      this.defineProxyFn({ value: option.label.label })
    },
    /** 下拉值的变化响应 */
    defineProxyFn ({ value }) {
      if (this.formContentArray.length !== 0) {
        this.formContentArray.forEach(opt => {
          if (opt.paramsName === this.choozeArray[0].paramsName) {
            if (opt.type === 'datetimerange') {
              const content = `${value[0]} -- ${value[1]}`
              this.$set(opt, 'content', content)
            } else {
              this.$set(opt, 'content', value)
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.searchComponent {
  .select ::v-deep .el-input,
  .select ::v-deep .el-input__inner {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  ::v-deep .icon.el-popover__reference {
    border-radius: 0;
  }

  .param ::v-deep input {
    border-radius: 0 !important;
  }

  .reset {
    border-radius: 0 !important;
    border: #dcdfe6 1px solid;
    border-left: none;
    border-right: none;
  }

  .search {
    border-radius: 0 2px 2px 0 !important;
    border-color: var(--primary-color) !important;
  }

  height: auto;

  // z-index: 2;
  .formPage {
    height: 50px;
    border-bottom: 1px solid #dcdfe6;
    box-sizing: border-box;
    z-index: 1;

    .el-form {
      padding-top: 10px;
      box-sizing: border-box;
    }

    ::v-deep .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
    }

    ::v-deep .el-form-item__content {
      line-height: 27px !important;
    }

    .formBtn {
      min-width: 0;
      margin-right: 0;
      border-color: #dcdfe6;

      ::v-deep .el-icon-refresh {
        color: var(--primary-color);
      }
    }
  }

  .formContent {
    height: auto;
    max-height: 100px;
    padding: 5px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid #dcdfe6;
    box-sizing: border-box;

    .fromContentBox {
      height: 40px;
      line-height: 40px;
      margin-right: 10px;

      .titleText,
      .paramContent {
        border: 1px solid var(--primary-color);
        padding: 5px;
        box-sizing: border-box;
        border-radius: 0 2px 2px 0;
      }

      .titleText {
        color: #fff;
        background-color: var(--primary-color);
        border-radius: 2px 0 0 2px;
      }
    }
  }

  .icon {
    width: 30px;
    height: 30px;
    margin-top: 0;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    // border-left: 0px solid #c0c4cc;
    // border-right: 0px solid #c0c4cc;
    // border-top: 1px solid #c0c4cc;
    // border-bottom: 1px solid #c0c4cc;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    cursor: pointer;
  }

  ::v-deep .el-range-editor--mini.el-input__inner {
    height: 30px;
  }
}

button {
  margin-top: 0 !important;
  //border-radius: 2px !important;
}

.popoverForm {
  display: inline-block;
}

.popoverContent {
  display: flex;
  align-items: center;
  width: 150px;
  justify-content: space-around;

  .text {
    flex: 1;
    margin: 0 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .ckeckbox {
  }
}

.el-select-dropdown__list {
  max-height: 250px;
  min-height: 120px;
  overflow: auto;
}

.treeClass {
  width: 100%;
  height: 100%;
  overflow: auto;

  .el-tree {
    height: 100%;
  }
}

// 居然不能识别到全局变量
$width-lg: 1200px;
$width-xl: 1600px;

@media screen and (min-width: $width-lg) {
  .select {
    width: 150px;
  }

  .param {
    width: 200px;
  }

  // .param-date-picker {
  //     width: 250px;
  // }
}

@media screen and (min-width: $width-xl) {
  .select {
    width: 193px;
  }

  .param {
    width: 250px;
  }

  .param-date-picker {
    width: 320px;
  }
}

.to-parent-class {
  display: flex;

  .to-class {
    //margin: 0px 5px;
    // display: inline-block;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    width: 30px;
    text-align: center;
    height: 28px;
  }
}
</style>
